import {AdminPagingModel} from "./AdminPagingModel";
import {FixedVTag} from "../../entities/FixedVTag";
import {FixedVTagService} from "../../services/FixedVTagService";
import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class FixedVTagAdminPagingModel extends AdminPagingModel<FixedVTag> {
    static $inject = ['$q', 'FixedVTagService', 'NotificationService', 'ApplicationSettingService', 'GridBookmarkService'];
    useMeters: boolean = true;

    constructor($q: ng.IQService,
                pagingService: FixedVTagService,
                notificationService: NotificationService,
                public applicationSettingService: ApplicationSettingService,
                gridBookmarkService: GridBookmarkService) {
        super($q, pagingService, notificationService, gridBookmarkService);
    }

    getCustomActions(): string[] {
        return ["Export"];
    }

    entityName(): string {
        return "fixedvtag";
    }

    displayName(): string {
        return "Fixed V-Tags";
    }

    addEditAllowed(): boolean {
        return true;
    }

    deleteAllowed(): boolean {
        return true;
    }

    transformItem(entity: FixedVTag) {
        if (!this.useMeters) {
            var xStr = (entity.vTagX * 3.28084).toFixed(2);
            var yStr = (entity.vTagY * 3.28084).toFixed(2);
            entity.vTagX = Number(xStr);
            entity.vTagY = Number(yStr);
        }
    }

    getColumnDefs(): ng.IPromise<void> {
        return this.applicationSettingService.getUseMeters().then((useMeters) => {
            this.useMeters = useMeters;
            this.nameValuePairs =
                [
                    ['vTagID', 'V-Tag ID', 100],
                    ['name', 'Name', 100],
                    ['locationName', 'Location', 215],
                    ['readerName', 'Reader Name', 150],
                    ['vTagLastSeen', 'V-Tag Last Seen', 175],
                    ['batteryLevel', 'Battery Level', 150],
                    ['vTagX', 'V-Tag X', 110],
                    ['vTagY', 'V-Tag Y', 110],
                    ['vTagZ', 'V-Tag Z', 110]
                ];
            return this.$q.when();
        });
    }
}
